import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=4d99d9b8&scoped=true&"
import script from "./layer.vue?vue&type=script&lang=js&"
export * from "./layer.vue?vue&type=script&lang=js&"
import style0 from "./layer.vue?vue&type=style&index=0&id=4d99d9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d99d9b8",
  null
  
)

export default component.exports